import { Button } from "@mui/material";
import React from "react";

function AppButton({ children, onClick, selected }) {
  const styles = {
    button: {
      background: selected ? "#2DD07F" : "#E0E0E0",
      borderRadius: "8px",
      color: selected ? "white" : "#A4A4A4",
      fontSize: 16,
      fontWeight: 500,
      boxShadow: "none",
      margin: "4px",
      "&:hover": {
        background: "rgb(38, 182, 110)",
        color: "white",
        opacity: 0.8,
      },
    },
  };

  return (
    <Button onClick={onClick} sx={[styles.button, {}]} variant="contained">
      {children}
    </Button>
  );
}

export default AppButton;
